<template>
  <div class="card">
    <div class="loader" v-if="isLoading"></div>
    <div v-else>
      <div class="card-header">
        <div>ATTENDANCE LOG</div>
        <div class="control-group">
          <div class="control-title">MONTH</div>
          <select class="control" v-model="month.selected">
            <option
              v-for="option in month.data"
              :key="option.id"
              :value="option.id"
            >
              {{ option.name }}
            </option>
          </select>
        </div>
        <div class="control-group">
          <div class="control-title">YEAR</div>
          <select class="control" v-model="year.selected">
            <option v-for="(option, optionIdx) in year.data" :key="optionIdx">
              {{ option }}
            </option>
          </select>
          <!-- <div>
            <b>{{year.selected}}</b>
          </div>-->
        </div>
      </div>
      <div class="card-group">
        <Summary :items="listSummary" />
        <AttLogAttendance
          title="Attendance"
          :list="listAttendance"
          :profile="profile"
          :id="id"
          @shouldReload="reloadTable"
        />
        <AttLogTimeoffs
          title="Time Offs"
          :list="listTimeoff"
          :profile="profile"
          :id="id"
          @shouldReload="reloadTable"
        />
        <AttLogDeductions
          title="Deductions"
          :list="listDeductions"
          :profile="profile"
          :id="id"
          :attendance="listAttendance"
          @shouldReload="reloadTable"
        />
      </div>
      <div style="padding: 10px">
        <div
          style="
            border-top-color: #bdc3c7;
            margin-top: 20px;
            border-top: double;
          "
        />
        <table style="margin-top: 20px">
          <tfoot>
            <tr v-if="totalAttendance > 0">
              <td>Attendance</td>
              <td>{{ toRupiah(totalAttendance) }}</td>
            </tr>
            <tr v-if="totalTimeoff > 0">
              <td>Time Offs</td>
              <td>{{ toRupiah(totalTimeoff) }}</td>
            </tr>
            <tr v-if="totalDeductions > 0">
              <td>Deductions</td>
              <td>{{ toRupiah(totalDeductions) }}</td>
            </tr>
            <tr>
              <td>Grand Total</td>
              <td>{{ toRupiah(grandTotal) }}</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { http } from '../digilib_web/core/digitify';
import { constants, regentsUtils } from '../js/regents';
import Summary from './timeoff_summary';
import AttLogAttendance from './att_log_attendance';
import AttLogTimeoffs from './att_log_timeoffs';
import AttLogDeductions from './att_log_deductions';

export default {
  props: {
    profile: Object,
    id: Number
  },
  components: {
    Summary,
    AttLogAttendance,
    AttLogTimeoffs,
    AttLogDeductions
  },
  watch: {
    'month.selected': {
      handler(n, prev) {
        // reload only if prev is not null
        if (prev) {
          this.reloadTable();
        }
      }
    },
    'year.selected': {
      handler(n) {
        this.reloadTable();
      }
    }
  },
  mounted() {
    // set selected month and year
    let m = dayjs();
    this.month.selected = parseInt(m.format('M'), 10);
    this.year.selected = parseInt(m.format('YYYY'), 10);
    let id = this.id;
    let curYear = this.year.selected;
    let endpoint = `employees/attendance?select=clock_in,clock_out&where=id_employee,=,${id}|date,>=,${curYear}-01-01|date,<=,${curYear}-12-31`;
    http.get(endpoint).then(json => {
      this.countLate = regentsUtils.countAnnualLateness(
        json.data,
        this.profile.department
      );
      this.reloadTable();
    });
  },
  computed: {
    listSummary() {
      let all = [...this.listAttendance, ...this.listTimeoff];
      return all;
    },
    totalAttendance() {
      let total = 0;
      this.listAttendance.forEach(a => {
        total += a.deduction_amount || 0;
      });
      return total;
    },
    totalTimeoff() {
      let total = 0;
      this.listTimeoff.forEach(a => {
        total += a.deduction || 0;
      });
      return total;
    },
    totalDeductions() {
      let total = 0;
      this.listDeductions.forEach(a => {
        total += a.deduction || 0;
      });
      return total;
    },
    grandTotal() {
      let total =
        this.totalAttendance + this.totalTimeoff + this.totalDeductions;
      return total;
    }
  },
  methods: {
    toRupiah(t) {
      return `- Rp. ${t.toLocaleString()}`;
    },
    reloadTable() {
      // load attendance
      this.isLoading = true;
      const m = this.month.selected;
      const y = this.year.selected;
      let endpoint = `employees/attendance/monthly/${m}/${y}?where=id_employee,=,${
        this.id
      }`;
      // reload
      http.get(endpoint).then(json => {
        this.isLoading = false;
        this.list.data = json.data;
        this.generateTableData();
      });
    },
    generateTableData() {
      // clone the list data, sort by date
      let rows = Object.assign([], this.list.data).filter(x =>
        dayjs(x.date).isBefore(dayjs())
      );
      rows.sort((a, b) => {
        return dayjs(a.date).isBefore(b.date) ? 1 : -1;
      });

      let filteredRows = [];
      for (let i = 0; i < rows.length; ++i) {
        let row = rows[i];
        row.d = rows[i].date;
        rows[i] = regentsUtils.attendanceDeduction(row, this.countLate);
        rows[i].isEditing = false;
        filteredRows.push(rows[i]);
      }

      this.listTimeoff = filteredRows.filter(x => x.tag === 'timeoff');
      this.listDeductions = filteredRows.filter(x => x.tag === 'deduction');
      this.listAttendance = filteredRows.filter(x => x.tag === 'attendance');
    }
  },
  data() {
    return {
      isLoading: true,
      countLate: 0,
      listAttendance: [],
      listTimeoff: [],
      listDeductions: [],
      list: {
        data: []
      },
      month: {
        data: constants.MONTHS,
        selected: null
      },
      year: {
        data: constants.YEARS,
        selected: null
      }
    };
  }
};
</script>

<style>
.control-group {
  display: flex;
  align-items: center;
}
.control {
  border: 1px solid #cecece;
  padding: 0.6em 1.4em 0.5em 0.8em;
  font-size: 0.8rem;
  height: 35px;
  color: #464a4c;
  border-radius: 0.25rem;
}
.select {
  border: 1px solid #cecece;
  padding: 0.6em 1.4em 0.5em 0.8em;
  font-size: 0.8rem;
  height: 35px;
  color: #464a4c;
  border-radius: 0.25rem;
}
.control-title {
  margin-right: 10px;
  font-size: 0.8em;
}
.card {
  flex: 1 1 auto;
  font-size: 0.9em;
  box-shadow: 0 0 1px 1px rgba(222, 226, 222, 0.5);
}
.card-header,
.card-group {
  display: -webkit-flex;
  display: flex;
  padding: 8px;
}
.card-group {
  flex-flow: column;
}
.card-header {
  background-color: #f7f8f7;
  margin-bottom: 1rem;
  padding-top: 0.5rem;
  font-size: 1rem;
  font-weight: bold;
  line-height: 1.1;
  color: #001b3d;
  text-transform: uppercase;
  display: -webkit-flex;
  display: flex;
  justify-content: space-between;
}
.header-group {
  display: flex;
  justify-content: space-between;
}
.box {
  box-shadow: 0 0 1px 1px rgba(222, 226, 222, 0.5);
}
.box-header-group {
  display: flex;
  justify-content: space-between;
  background-color: #ecf0f1;
  padding: 10px;
}
.box-content-group {
  padding: 10px;
  display: flex;
  flex-flow: column;
}
.emp-details-group {
  display: flex;
  justify-content: space-between;
  line-height: 2em;
}
.green-label {
  color: #5fb1a0;
}
.red-label {
  color: #cf000f;
}
.footer {
  margin-top: 50px;
}
.footer-btn-group {
  display: flex;
  justify-content: center;
}
.btn-absence-group {
  display: flex;
  cursor: pointer;
}
.table-value-group {
  display: flex;
  justify-content: space-between;
}
.table-value-group > input {
  padding: 0.5em;
  border: 1px solid #cecece;
  font-size: 0.9rem;
  color: #464a4c;
  height: 28px;
  border-radius: 0.2rem;
}
table {
  box-shadow: 0 0 1px 1px rgba(222, 226, 222, 0.5);
  border-collapse: collapse;
  width: 100%;
  table-layout: fixed;
}
table tr {
  background-color: #f8f8f8;
  border: 1px solid #ddd;
  padding: 0.35em;
}
tbody tr:nth-child(odd) {
  background-color: white;
}
tbody td,
thead td {
  border: 1px solid #dddddd;
}
tfoot td {
  background-color: white;
  font-weight: bold;
}
table th,
table td {
  padding: 0.625em;
}
table th {
  font-size: 0.85em;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}
.pointer {
  cursor: pointer;
}
@media screen and (max-width: 768px) {
  table th,
  table td {
    padding: 0.5em;
  }
  .emp-details-group {
    flex-flow: column;
  }
  .table-value-group > input {
    width: 80px;
    padding: 0.1em;
  }
  .card-header {
    flex-flow: column;
  }
  .card-group {
    padding: 0;
  }
  .control-group {
    padding: 5px;
    justify-content: space-between;
    flex: 1 1 auto;
  }
  .control {
    width: 180px;
    height: 32px;
  }
  .select {
    width: 100px;
  }
}
</style>
